const state = {
  expanded: false,
  showSearchbar: false,
  showUserNav: false
}

const mutations = {
  EXPAND (state) {
    state.expanded = true
  },
  COLLAPSE (state) {
    state.expanded = false
  },
  TOGGLE (state) {
    state.expanded = !state.expanded
  },
  SET_SEARCHBAR (state, value) {
    state.showSearchbar = value
  },
  SET_USER_NAV (state, value) {
    state.showUserNav = value
  }
}

const actions = {
  expand ({commit}) {
    commit('EXPAND')
  },
  collapse ({commit}) {
    commit('COLLAPSE')
  },
  toggle ({commit}) {
    commit('TOGGLE')
  },
  setSearchbar ({commit, state}, value) {
    if (state.showSearchbar !== value) {
      commit('SET_SEARCHBAR', value)
    }
  },
  setUserNav ({commit, state}, value) {
    if (state.showUserNav !== value) {
      commit('SET_USER_NAV', value)
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./frontend/src/store/modules/layout.js